import { useEffect } from 'react';
import type { IUXFProperties } from 'UXF';
import { UXF } from 'UXF';

import { useCurrentUserStore } from 'store/currentUser';

import { useConferenceId } from 'hooks/useConferenceId';

import { getEnvironment } from 'utils/getEnvironment';

export function useSetUXFParameters() {
    const { currentUser } = useCurrentUserStore();
    const conferenceId = useConferenceId();
    const environment = getEnvironment();

    useEffect(() => {
        if (currentUser && conferenceId !== undefined) {
            const properties: IUXFProperties = {
                environment,
                meeting_id: conferenceId,
                meeting_user_role: currentUser.role,
                user_id: currentUser.id,
            };

            UXF.setProperties(properties);
        }
    }, [conferenceId, currentUser?.role, currentUser?.id]);
}
